import SignupPage from "@/pages/signup-page"
import createComponent from "@/utils/create-component"

const rootElement = document.getElementById("vue_signup_form")

if (rootElement) {
  createComponent({
    el: rootElement,
    component: SignupPage
  })
}
